module.exports = __webpack_public_path__ + "img/4.18843982.png";